import { spacing, typography, colors } from "deprecated-theme"
import React from "react"

const ICON: React.CSSProperties = {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  marginRight: 5,
}

const TEXT: React.CSSProperties = {
  fontFamily: typography.primary,
  fontSize: 12,
  lineHeight: "16px",
  paddingTop: 4,
  paddingBottom: 4,
}

const CONTAINER: React.CSSProperties = {
  padding: `${spacing[1]}px ${spacing[4]}px`,
  marginRight: spacing[2],
  marginBottom: spacing[2],
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 4,
  backgroundColor: colors.line,
}

export const viewPresets = {
  default: CONTAINER,
  neutral: {
    ...CONTAINER,
    backgroundColor: colors.textDark,
  },
  error: {
    ...CONTAINER,
    backgroundColor: colors.error,
  },
  option: {
    ...CONTAINER,
    justifyContent: "flex-start",
  },
}

export const textPresets = {
  default: { ...TEXT },
  neutral: {
    ...TEXT,
    color: colors.textInverted,
  },
  error: {
    ...TEXT,
    color: colors.textInverted,
  },
  option: {
    ...TEXT,
    fontSize: 18,
    lineHeight: "22px",
  },
}

export const iconPresets = {
  default: { ...ICON },
  neutral: { ...ICON },
  option: { ...ICON },
}

export type TagPresets = keyof typeof viewPresets
